<div class="row principalDarkerBackground centrado fullHeight">
  <div class="card width90 centrado">
    <div class="card-container">
      <div class="row">
        <div class="col-md-12">
          <h3 class="colorPrincipal">CAPTURA CÉDULA</h3>
        </div>
        <div class="col-md-12">
          <p class="colorSecundario fontItalic">Evite un ambiente carente de luz, procure evitar sombras y reflejos
            excesivos en el documento. <br> Evite cualquier objeto en el fondo de la captura para lograr contraste</p>
        </div>
        <div class="col-md-12">
          <h3 class="colorPrincipal">ORIENTACIÓN CORRECTA DE LA CEDULA</h3>
        </div>
        <div class="col-md-12 centrado padding10" *ngIf="deviceChecked.isMobile">
          <img
                  src="../../../assets/images/rut.png" />
        </div>
        <div class="col-md-12 centrado padding10" *ngIf="deviceChecked.isDesktop">
          <img
                  src="../../../assets/images/desktopMockup.png" />
        </div>
        <div class="col-md-12 centrado padding10"  *ngIf="activateButton">
          <div class="col-md-3"></div>
          <div class="col-md-4 col-sm-6">
            <a class="nav-link botonID principalBackground padding10" routerLink="/scanRut">
              OK  </a>
          </div>
          <div class="col-md-3"></div>
        </div>

      </div>

    </div>

  </div>
</div>
